import { createBrowserRouter } from 'react-router-dom';

import { MainLayout } from 'app/layouts';
import { Brand } from 'pages/Brand';
import { Catalog } from 'pages/Catalog';
import { AddChannel, Channel, Channels, EditChannel } from 'pages/Channels';
import { Dashboard } from 'pages/Dashboard';
import { Finances } from 'pages/Finances';
import { More } from 'pages/More';
import { NotFound } from 'pages/NotFound';
import { History, Planner } from 'pages/Planner';
import { EditPost } from 'pages/Post';
import { Profile } from 'pages/Profile';
import { Reports } from 'pages/Reports';
import { Settings } from 'pages/Settings';
// import { Tasks } from 'pages/Tasks';
import { EMainRoutes } from 'shared/typings';

const appRouter = createBrowserRouter([
	{
		path: '/',
		element: <MainLayout />,
		errorElement: <MainLayout outlet={<NotFound />} />,
		children: [
			{
				path: EMainRoutes.DASHBOARD,
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.CHANNELS,
				element: <Channels />,
			},
			{
				path: `${EMainRoutes.CHANNELS}/${EMainRoutes.CREATE}`,
				element: <AddChannel />,
			},
			{
				path: `${EMainRoutes.CHANNEL}/:id`,
				element: <Channel />,
			},
			{
				path: `${EMainRoutes.CHANNELS}/${EMainRoutes.EDIT}/:id`,
				element: <EditChannel />,
			},
			{
				path: EMainRoutes.PLANNER,
				element: <Planner />,
			},
			{
				path: EMainRoutes.HISTORY,
				element: <History />,
			},
			{
				path: EMainRoutes.CATALOG,
				element: <Catalog />,
			},
			{
				path: `${EMainRoutes.BRAND}/:id`,
				element: <Brand />,
			},
			{
				path: `${EMainRoutes.POST}/${EMainRoutes.EDIT}/:plannerPostId`,
				element: <EditPost />,
			},
			{
				path: `${EMainRoutes.POST}/${EMainRoutes.CREATE}`,
				element: <EditPost />,
			},
			{
				path: EMainRoutes.FINANCES,
				element: <Finances />,
			},
			{
				path: EMainRoutes.REPORTS,
				element: <Reports />,
			},
			// {
			// 	path: EMainRoutes.TASKS,
			// 	element: <Tasks />,
			// },
			{
				path: EMainRoutes.PROFILE,
				element: <Profile />,
			},
			{
				path: EMainRoutes.SETTINGS,
				element: <Settings />,
			},
			{
				path: EMainRoutes.MORE,
				element: <More />,
			},
		],
	},
]);

export default appRouter;
